// extracted by mini-css-extract-plugin
module.exports = {"assets":"Styles_assets__bKLky","assets__item":"Styles_assets__item__fvUeG"};